<template>
  <div class="box">
    <h3 class="title is-3">
      <router-link :to="{ name: 'post.show', params: { id: post.id}}">
        {{ post.title }}
      </router-link>
    </h3>
    <p class="subtitle">
      {{ post.title }}
    </p>
    <p>
      {{ post.postedAt }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    post: Object
  }
}
</script>
